const InterchangeIcon = ({
  color,
  height = 32, 
  width = 32,
  uniqueId,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M20.6667 18.12V12.6667C20.6667 11.1933 19.4733 10 18 10C16.5267 10 15.3333 11.1933 15.3333 12.6667V19.3333C15.3333 20.0667 14.7333 20.6667 14 20.6667C13.2667 20.6667 12.6667 20.0667 12.6667 19.3333V13.88C13.44 13.6 14 12.8667 14 12C14 10.8933 13.1067 10 12 10C10.8933 10 10 10.8933 10 12C10 12.8667 10.56 13.6 11.3333 13.88V19.3333C11.3333 20.8067 12.5267 22 14 22C15.4733 22 16.6667 20.8067 16.6667 19.3333V12.6667C16.6667 11.9333 17.2667 11.3333 18 11.3333C18.7333 11.3333 19.3333 11.9333 19.3333 12.6667V18.12C18.56 18.3933 18 19.1267 18 20C18 21.1067 18.8933 22 20 22C21.1067 22 22 21.1067 22 20C22 19.1333 21.44 18.4 20.6667 18.12Z" fill={color} />
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default InterchangeIcon;
